<template>
  <div class="custom-svg">
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="icon === 'embibe'">
      <path d="M10.7476 3.77135e-07C7.92842 0.069874 5.24326 1.21783 3.24484 3.20758C1.24642 5.19733 0.0868081 7.87747 0.00467925 10.6963C-0.0774496 13.5152 0.924158 16.2583 2.80334 18.361C4.68253 20.4638 7.29629 21.7661 10.1066 22C8.27594 21.6216 6.59903 20.7076 5.28897 19.3741C4.34751 18.4741 3.59827 17.3927 3.08652 16.195C2.57477 14.9974 2.31113 13.7084 2.31153 12.406C2.31215 10.3142 3.0435 8.28838 4.3792 6.67857C5.09827 5.8008 5.99939 5.08965 7.02026 4.5943C8.04113 4.09894 9.1574 3.8312 10.2919 3.80957C11.4264 3.78794 12.5521 4.01295 13.5911 4.46903C14.6301 4.92512 15.5576 5.6014 16.3096 6.45113C17.2392 7.55761 17.8345 8.90593 18.0258 10.3383C18.1764 11.1281 18.1049 11.9441 17.819 12.6955C17.3848 13.5639 16.5991 13.7086 15.586 13.7293H9.54837C9.37286 13.7321 9.19856 13.6999 9.03561 13.6346C8.87267 13.5693 8.72433 13.4723 8.59926 13.3491C8.47418 13.226 8.37485 13.0792 8.30706 12.9172C8.23927 12.7553 8.20436 12.5815 8.20439 12.406C8.20434 12.0586 8.34092 11.7251 8.58463 11.4775C8.82835 11.2299 9.15965 11.0881 9.50702 11.0827L14.6969 10.9793C14.945 10.9793 15.0897 10.9793 15.1931 10.8139C15.2312 10.6928 15.2312 10.5629 15.1931 10.4417C15.1182 9.63449 14.7846 8.87302 14.242 8.27068C13.6946 7.62108 12.9939 7.11827 12.2032 6.80778C11.4125 6.49729 10.5569 6.38892 9.71378 6.49248C8.37073 6.72309 7.15841 7.43697 6.30528 8.49957C5.45215 9.56218 5.01713 10.9001 5.08221 12.2613C5.06132 13.1678 5.20133 14.0709 5.49574 14.9286C5.94507 16.1461 6.70833 17.2233 7.70815 18.0508C9.06206 19.1354 10.713 19.7843 12.4431 19.9117C13.8671 20.0559 15.3046 19.8399 16.6233 19.2835C17.9421 18.7271 19.0998 17.8482 19.9901 16.7274C20.6401 15.8816 21.1241 14.9205 21.4168 13.8947C21.8544 12.2588 21.9099 10.5441 21.5789 8.88329C21.2479 7.22248 20.5393 5.66006 19.508 4.31688C18.4766 2.9737 17.1501 1.88576 15.631 1.13721C14.112 0.38866 12.4411 -0.000442205 10.7476 3.77135e-07Z" :fill="color"/>
    </svg>
    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="icon === 'user'">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4695 4.93025C12.4695 7.65316 10.2622 9.86051 7.53927 9.86051C4.81637 9.86051 2.60902 7.65316 2.60902 4.93025C2.60902 2.20735 4.81637 0 7.53927 0C10.2622 0 12.4695 2.20735 12.4695 4.93025ZM5.72535 11.2092H9.39978C12.051 11.2092 14.2835 13.2092 14.6091 15.8138L15.1207 20.0929C15.1672 20.6511 14.8417 21.2092 14.2835 21.3022C12.144 21.7673 9.95792 21.9999 7.58582 21.9999C5.21372 21.9999 2.98115 21.7673 0.841608 21.3022C0.283466 21.1627 -0.0421167 20.6511 0.00439517 20.0929L0.516026 15.8138C0.841609 13.2092 3.07418 11.2092 5.72535 11.2092Z" :fill="color"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 40 40" v-if="icon === 'play'" :fill="color">
      <path d="m35.4 20.7l-29.6 16.5q-0.6 0.3-0.9 0t-0.4-0.8v-32.8q0-0.6 0.4-0.8t0.9 0l29.6 16.5q0.5 0.3 0.5 0.7t-0.5 0.7z"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 40 40" v-if="icon === 'stop'" :fill="color">
      <path d="m37.3 4.3v31.4q0 0.6-0.4 1t-1 0.4h-31.5q-0.6 0-1-0.4t-0.4-1v-31.4q0-0.6 0.4-1t1-0.4h31.5q0.5 0 1 0.4t0.4 1z"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 40 40" v-if="icon === 'pause'" :fill="color">
      <path d="m37.3 4.3v31.4q0 0.6-0.4 1t-1 0.4h-11.5q-0.6 0-1-0.4t-0.4-1v-31.4q0-0.6 0.4-1t1-0.4h11.5q0.5 0 1 0.4t0.4 1z m-20 0v31.4q0 0.6-0.4 1t-1 0.4h-11.5q-0.6 0-1-0.4t-0.4-1v-31.4q0-0.6 0.4-1t1-0.4h11.5q0.5 0 1 0.4t0.4 1z"/>
    </svg>
  </div>
</template>

<script>

export default {
  name: "CustomSvg",
  components: {},
  props: {
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#7367f0'
    }
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  watch: {

  },
  methods: {

  },
}

</script>
